import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import PrivacyPolicy from "./components/PrivacyPolicy"; // ✅ import
import TermsOfService from "./components/TermsOfService"; // ✅ if you have it
import FAQ from "./components/FAQ";
import Invite from "./components/Invite";
import Profile from "./components/Profile";
import Media from "./components/Media";
import PixPouch from "./components/PixPouch";

function LandingPage() {
  return (
    <>
      <Navbar />
      <main>
        <section id="home">
          <Hero />
        </section>
        <section id="features">
          <Features />
        </section>
        <section id="how-it-works">
          <HowItWorks />
        </section>
        <section id="about">
          <About />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background text-foreground">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/faqs" element={<FAQ />} />
          <Route path="/invite" element={<Invite />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/media" element={<Media />} />
          <Route path="/pix-pouch" element={<PixPouch />} />
        </Routes>
      </div>
    </Router>
  );
}
